import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import '../../src/assets/Styles/CommonCSS/Default.css';
import FooterComponent from "../components/common/footer";
import HeaderComponent from "../components/common/header";

const MainLayout = ({affSelected}) => {
    
    const { isLoggedIn } = useSelector((store) => store.login);
    const location = useLocation();
    const { loginData } = useSelector((store) => store.login);
    
    if (location.pathname.toLowerCase() == "/") {
        return <Navigate to="/Dispatch" />
    }
    else if (!isLoggedIn && location.pathname.toLowerCase() !== "/login" && location.pathname.toLowerCase() !== "/loginauto") {
        return <Navigate to="/Login" />
    }
    else if (location.pathname.toLowerCase() === "/login") {
        return (<div><HeaderComponent affSelected={affSelected} loginData={loginData}/><Outlet /><FooterComponent /></div>)
            
    }
    else {

        return (
            <div>
                {location.pathname.toLowerCase() !== "/callagent"? <HeaderComponent affSelected={affSelected} loginData={loginData}/>:""}
                    <Outlet />
                {location.pathname.toLowerCase() !== "/callagent"? <FooterComponent />:""}
            </div>
        )
    }
};

export default MainLayout;
